/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-no-bind */

import classnames from "classnames";
import Accordion from "component/design-system/accordion/Accordion";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import withShoppingCartState from "hoc/withShoppingCartState";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { useState } from "react";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { capitalize } from "util/lodash/capitalize";
import { maskText } from "util/lodash/maskText";
import EnterPostalCode from "../summary-shopping-cart/EnterPostalCode";
import styles from "./shippingCheckEstimator.module.scss";

const ShippingCheckEstimatorContent = dynamic(() => import(/* webpackChunkName: "shipping-content" */"./ShippingCheckEstimatorContent"));

function ShippingCheckEstimatorNew(props: any) {
  const [isPostalCodeActive, setIsPostalCodeActive] = useState(false);
  const { t } = useTranslation("shopping-cart");
  const shoppingCart = useSelector((state: RootState) => state.shoppingCart);
  const { city, ipLocation } = shoppingCart;
  let { postalCode } = shoppingCart;
  const { defaultPostalCode, title = t("Delivery Options For") } = props;
  if (defaultPostalCode) {
    postalCode = defaultPostalCode;
  }

  const noPostalCode = !(postalCode || ipLocation);

  function handleToggleAccordion(isActive: boolean) {
    // accordion active state is being set to enable dynamic loading of accordion content
    // it is only set while opening the accordion to enable smooth scrolling
    // smooth scroll will not work while closing accordion if this condition is removed
    if (isActive) {
      setIsPostalCodeActive(isActive);
    }
  }
  return (
    <Accordion
      className={classnames(styles.shipping_check_estimator, {
        [styles.shipping_check_estimator_none]: noPostalCode,
      })}
      titleClassName={styles.accordion}
      contentClassName={styles.accordion_content}
      isOpen={!postalCode || isPostalCodeActive ? "active" : ""}
      contentHeight="calc(8 * var(--safari-root-font, 10px))"
      handleToggleAccordion={handleToggleAccordion}
      isExpandable={Boolean(postalCode)}
      data-testid="delivery-option"
      allowDynamicHeight
      title={(
        <>
          <HideIf show={postalCode}>
            <div className="d-flex align-items-center">
              <PAText className={styles.title_text} color="black" fontSize={FONT_SIZE[0]}>
                {`${title }:`}
              </PAText>
              <span className={styles.title_text} />
              <PAText className={styles.address_container} fontSize={FONT_SIZE[0]}>
                <span className={styles.postal_code}>
                  {maskText(postalCode, 3)}
                </span>
                {city && (
                  <span title={city}>
                    - &nbsp;
                    {capitalize(city)}
                  </span>
                )}
              </PAText>
            </div>
          </HideIf>
          <EnterPostalCode />
        </>
      )}
      content={(
        <HideIf show={isPostalCodeActive}>
          <ShippingCheckEstimatorContent
            classNameCard={props.classNameCard}
          />
        </HideIf>
      )}
    />
  );
}

function SkeletonV2() {
  return <LoaderSkeleton height={25} className="m-b-10" />;
}

export default withShoppingCartState(ShippingCheckEstimatorNew, SkeletonV2);
